/**
 *  Created by piotr@revisual.io on 14/08/2025
 */

import { useEffect, useRef } from "react";

export function useAnimateIn(delay = 0) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    // Hide immediately before triggering animation
    el.classList.remove("animate-in");
    el.style.opacity = "0";

    // Trigger in next frame so DOM updates first
    const timeout = setTimeout(() => {
      el.style.animationDelay = `${delay}s`;
      el.classList.add("animate-in");
    }, 0);

    return () => clearTimeout(timeout);
  }, [delay]);

  return ref;
}

export default useAnimateIn;
